

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { EnumDocumentTypes } from './../enums';
import { EnumPaymentMethod } from './../enums';
import { EnumDeliveryMethods } from './../enums';
export class MakePaymentParams extends BaseEntity
{   
    public Sum: number; 
    public Currency: string; 
    public NumberOfPayments: number; 
    public CompanyID: number; 
    public Email: string; 
    public DocumentsType: EnumDocumentTypes; 
    public DocumentIDs: number[]; 
    public DocumentLineIDs: number[]; 
    public PaymentMethod: EnumPaymentMethod; 
    public DeliveryMethod: EnumDeliveryMethods; 
	public SessionID: string;
}



